import { Client } from "../model/Client";

export const buildSelectedClientQuery = (clients: Client[]) => {
    let querys:string[] = [];
    clients.map((client:Client) => querys.push(`cid=${client.id}`));
    return querys.join("&");
}